import { Button } from "@/components/ui/button";
import { STATUS } from "@/config/progress";
import { Status } from "@/schema/app/assessment/status";
import { useTranslation } from "react-i18next";

interface AssessorProgressProps {
  status: Status;
}

function ProgressStatus({ status }: AssessorProgressProps) {
  const { t } = useTranslation();
  const text2Obj: {
    [key: number]: string;
  } = {
    3: t("hearing"),
    4: t("hearing"),
    5: t("hearing"),
    6: t("hearing"),
    7: t("initial-assessment-completed"),
    8: t("under-re-assessment"),
    9: t("under-re-assessment"),
    10: t("under-re-assessment"),
    11: t("under-re-assessment"),
    12: t("applied-for-certificate"),
    13: t("certificate-issued"),
  };

  const text3Obj: {
    [key: number]: string;
  } = {
    3: t("hearing-message"),
    4: t("hearing-message"),
    5: t("hearing-message"),
    6: t("hearing-message"),
    7: t("check-report-message"),
    8: t("re-assessment-message"),
    9: t("re-assessment-message"),
    10: t("re-assessment-message"),
    11: t("re-assessment-message"),
    12: "",
    13: t("certifiicate-issued-message"),
  };

  const text1 =
    status.id === STATUS.CERTIFICATED_ISSUED
      ? t("congratulation")
      : t("current-progress");
  const text2 = text2Obj[status.id];
  const text3 = text3Obj[status.id];

  return status.id >= STATUS.SUBMITTED ? (
    <div className="my-card mt-8 p-5">
      <div className="flex flex-col gap-4">
        <div>
          <div className="font-medium text-cool-gray-600">{text1}</div>
          <div className="font-medium text-cool-gray-900">{text2}</div>
          <div className="text-cool-gray-600">{text3}</div>
        </div>
        {status.id === STATUS.CERTIFICATED_ISSUED && (
          <div className="flex gap-4">
            <Button
              onClick={() => {
                window.open(`/app/certificate`, "_blank");
              }}
            >
              {t("download-certificate")}
            </Button>
          </div>
        )}
      </div>
    </div>
  ) : null;
}

export default ProgressStatus;
